/**
 * Button with loader icon
 * - Adds support for deferring the action of a button click, to wait for some
 *   external action to resolve and show the loader in the mean time
 * - Proxies (overwrites) the style of the original Button component
 */
import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { GTM_CLICK_TRACKING_PROP_NAME } from 'constants/global'
import Button from '../Button'
import loaderStyles from './loaderButton.css'

class LoaderButton extends PureComponent {
  constructor (props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
    this.state = {
      isClicked: false
    }
  }

  componentDidUpdate () {
    /* istanbul ignore else */
    if (this.state.isClicked && !this.props.deferAction) {
      this.renderedButtonElement.click()
    }
  }

  render () {
    const {children, deferAction, ...otherProps} = this.props
    return (
      <Button
        className={deferAction ? loaderStyles.base : loaderStyles.isLoading}
        baseClassName={'primaryButton'}
        size={'large'}
        {...otherProps}
        // Button triggers the click event, so overwrite it's clickHandler function
        clickHandler={this.handleClick}
      >
        {children}
      </Button>
    )
  }

  handleClick (evt) {
    // Always show loader (TODO: on timeout?)
    this.renderedButtonElement = evt.target

    if (!this.state.isClicked) {
      this.props.clickHandler(evt)
    }

    this.setState({isClicked: true})
    if (this.props.deferAction) {
      // Ignore click and show loading state
      evt.preventDefault()
      evt.target.blur()
    } else {
      // Operate normally
      this.setState({isClicked: false})
    }
  }
}

LoaderButton.propTypes = {
  children: PropTypes.string.isRequired,
  clickHandler: PropTypes.func,
  deferAction: PropTypes.bool,
  [GTM_CLICK_TRACKING_PROP_NAME]: PropTypes.string
}

// Steal some default props from Button, they're tightly coupled anyway
LoaderButton.defaultProps = {
  clickHandler: Button.defaultProps.clickHandler,
  style: Button.defaultProps.style,
  deferAction: false,
  [GTM_CLICK_TRACKING_PROP_NAME]: null
}

export default LoaderButton
